"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getPath = function getPath(tool, isLocal) {
  if (isLocal) {
    return "";
  } else {
    return "".concat(tool, "/dist/");
  }
};
var _default = exports["default"] = getPath;